import Theme from '../styles/theme';

export const applyTheme = (state=Theme, action) => {
  switch (action.type) {
    case 'APPLY_THEME':
      return action.theme;
    default:
      return state;
  }
}

export const toggleMode = (state='light', action) => {
  switch (action.type) {
    case 'TOGGLE_MODE':
      return action.mode;
    default:
      return state;
  }
}
